import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { first } from 'lodash';

import S from 'constants/string.const';
import VACATION_TYPE from 'constants/timeoff/vacationType..const';
import { selectCurrentSalonCalendarMode } from 'selectors/currentSalon.selectors';

import CN from './CategoryTimeOffV1.module.scss';

const DATA = Object.freeze([
  Object.freeze({ who: 'Alice', allowed: '25', used: '2', remaining: '23' }),
  Object.freeze({ who: 'Bob', allowed: '20', used: '20', remaining: '0' }),
  Object.freeze({ who: 'Charlie', allowed: '25', used: '20', remaining: '5' }),
]);

const CategoryTimeOffItem = ({ emoji, index, type }) => (
  <div data-bem="CategoryTimeOffItem" data-index={index} className={CN.categoryItem}>
    {emoji}
    {S.space}
    {type}
  </div>
);

const CategoryTimeOffV1 = ({ calendarMode }) => {
  const firstVacationType = first(VACATION_TYPE);

  return (
    <div data-bem="CategoryTimeOff" className={cn(CN.banner, CN[calendarMode])}>
      <div className={CN.title}>
        <span data-bem="CategoryTimeOff__emoji-before" className={CN.emoji} role="img" aria-labelledby="Sound">
          📣
        </span>
        {S.space}
        {S.space}
        {`COMING SOON`}
        {S.space}
        {S.space}
        <span data-bem="CategoryTimeOff__emoji-after" className={CN.emoji} role="img" aria-labelledby="Sound">
          📣
        </span>
      </div>
      <div data-bem="CategoryTimeOff__note-1" className={CN.note}>
        1. Create categories for time off, eg:
      </div>
      <section data-bem="CategoryTimeOff__categories" className={CN.categoryList}>
        {VACATION_TYPE.map(({ emoji, type }, index) => (
          <CategoryTimeOffItem key={type} index={index} emoji={emoji} type={type} />
        ))}
      </section>
      <div data-bem="CategoryTimeOff__note-2" className={CN.note}>
        2. Set allowances per staff member & track time off used and days remaining:
      </div>
      <table data-bem="CategoryTimeOff__table" className={CN.table}>
        <thead>
          <tr>
            <th>
              <CategoryTimeOffItem {...firstVacationType} />
            </th>
            <th>Allowed</th>
            <th>Used</th>
            <th>Remaining</th>
          </tr>
        </thead>
        <tbody>
          {DATA.map(({ allowed, remaining, used, who }) => (
            <tr key={`${who}+${allowed}`}>
              <td>{who}</td>
              <td>{allowed} days</td>
              <td>{used} days</td>
              <td>{remaining} days</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const mapStateToProps = (state) => ({
  calendarMode: selectCurrentSalonCalendarMode(state),
});

const CategoryTimeOffV1Hoc = connect(mapStateToProps)(CategoryTimeOffV1);

export default CategoryTimeOffV1Hoc;
